<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        General.CREATE_DOCUMENT
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="close()">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <div class="item" @click="createDefaultDocument">
        <b-icon
          icon="file-document"
          size="is-big"
          :type="isContrast ? 'is-white-dark' : 'is-green-dark'"
        />
        <span>{{ General.NEW_DOCUMENT }}</span>
      </div>

      <div class="item" @click="createDoeDocument">
        <b-icon
          icon="text-box-check"
          size="is-big"
          :type="isContrast ? 'is-white-dark' : 'is-green-dark'"
        />
        <span>{{ App.OfficialModelsScreen.DOCUMENT_MODELS }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { General, App } from "@/utils/constants";
import ModalOfficialModels from "@/views/App/ModalOfficialModels";

export default {
  name: "ModalEditableDocument",
  props: {
    createDefault: {
      type: Function,
      default: () => null
    },
    processId: {
      type: String,
      default: ""
    },
    dispatchId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      App,
      General
    };
  },
  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    })
  },
  methods: {
    close() {
      this.$parent.close();
    },
    createDefaultDocument() {
      this.createDefault();
      this.close();
    },
    createDoeDocument() {
      this.$buefy.modal.open({
        parent: this,
        component: ModalOfficialModels,
        props: {
          onSelect: model =>
            this.$router.push({
              name: App.OfficialModelsScreen.VIEW_DOE,
              query: {
                modelId: model.id,
                processId: this.processId,
                dispatchId: this.dispatchId
              }
            })
        },
        hasModalCard: true,
        trapFocus: true
      });
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  max-height: 75vh;
  background-color: $color-1;
}

.modal-content-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  overflow: auto;
  margin: 0 auto;
  padding-bottom: 30px;
}

.item {
  display: flex;
  background-color: $background-color;
  padding: 10px;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 200px;
  margin: 20px;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid $background-color;
  span {
    margin-top: 10px;
    font-weight: 600;
    color: $color-7;
  }
  &:hover {
    border: 1px solid $color-12;
  }
}
</style>
